var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header ppf-branding-dots"},[_c('h1',{staticClass:"text-center text-white",attrs:{"id":"main"}},[_c('span',{staticClass:"text-title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }